/**
 * Erreurs du module Opportunity (Fiche de Poste)
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const OPPORTUNITY_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.OPPORTUNITY_TEMPLATE_NOT_FOUND]: {
        messageKey: 'job-sheet-word-template-not-found-you-can-add-one-in-admin-modules-and-select-job-sheets',
        severity: 'error',
    },
    [ERROR_CODES.OPPORTUNITY_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-the-opportunity',
        severity: 'error',
    },
    [ERROR_CODES.OPPORTUNITY_ALREADY_EXISTS]: {
        messageKey: 'this-job-sheet-already-exists-in-the-database',
        severity: 'error',
    },
    [ERROR_CODES.OPPORTUNITY_TEMPLATE_FILE_INVALID_FILE_TYPE]: {
        messageKey: 'the-template-file-must-be-in-docx-format',
        severity: 'error',
    },
};
